import { ExcalidrawCanvas } from './ExcalidrawCanvas'
import type { CanvasSelectedElement } from './ExcalidrawCanvas'
import type { ExcalidrawImperativeAPI } from '@excalidraw/excalidraw/types'

interface PrototypePaneProps {
  onAPIReady: (api: ExcalidrawImperativeAPI) => void
  initialData?: { elements: readonly any[]; files?: Record<string, any> }
  onChange?: (elements: readonly any[]) => void
  onSelectionChange?: (elements: CanvasSelectedElement[]) => void
  isAIDrawing?: boolean
}

export function PrototypePane({ onAPIReady, initialData, onChange, onSelectionChange, isAIDrawing = false }: PrototypePaneProps) {
  return (
    <div className="h-full">
      <ExcalidrawCanvas
        onAPIReady={onAPIReady}
        initialData={initialData}
        onChange={onChange}
        onSelectionChange={onSelectionChange}
        viewModeEnabled={isAIDrawing}
      />
    </div>
  )
}
